import React from 'react';
import { useIntl } from 'react-intl';
import { BlockDataForm } from '@plone/volto/components';
import { Schema } from './schema';

const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = Schema({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      formData={data}
      block={block}
      blocksConfig={blocksConfig}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
    />
  );
};
export default Data;
